import React, { useRef, useState } from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import { useFirebaseService } from '../../../data/FirebaseService';
import { useAuthService } from '../../login/authentication';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';

const LogoUpload: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [uploading, setUploading] = useState(false);

  const firebaseService = useFirebaseService();
  const authService = useAuthService();
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Handle file selection
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      handleUpload(e.target.files[0]);
    }
  };

  // Handle file upload
  const handleUpload = async (file: File) => {
    if (!file || !firebaseService) {
      setError('No file selected');
      return;
    }

    setLoading(true);
    setError(null);
    setUploading(true);

    try {
      const storageRef = ref(firebaseService.storage, `organization_logos/${authService.getOrgId()}/logo.png`);

      const metadata = {
        cacheControl: "public, max-age=31536000, immutable" // Cache for 1 year
      };
      // Upload the file
      const uploadTask = uploadBytesResumable(storageRef, file, metadata);

      // Wait for the upload to complete
      await uploadTask;

      // Get the file URL
      const logoUrl = await getDownloadURL(storageRef);
      console.log("Logo URL is " + logoUrl);
      // Save the URL to Firestore (under the organization document)
      await firebaseService.updateOrganizationDocument({
        logoUrl, // Update the logoUrl field
      });

      setUploading(false);
      alert('Logo uploaded successfully!');
    } catch (err) {
      setError('Error uploading logo. Please try again.');
      setUploading(false);
    }
    setLoading(false);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        style={{ display: 'none' }}
        id="logo-upload-input"
        ref={fileInputRef}
      />
      <label htmlFor="logo-upload-input" style={{ display: 'block' }}>
        <Button variant="text" color="secondary" style={{}} disabled={loading}
          onClick={() => fileInputRef.current?.click()}>
          {uploading ? <CircularProgress size={24} /> : 'Change Logo...'}
        </Button>
      </label>

      {error && <Typography color="error">{error}</Typography>}
    </div>
  );
};

export default LogoUpload;
